﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';
import dummy from '../../app/plugins';

//No internet
require('typeahead-addresspicker');

import tpl_customFriendlyUrl from './tpl/customFriendlyUrl.html';
import language from '../../../common/language';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';
import View_Information from '../../../lib/views/information/information';
import * as Entities_Empty from '../../../lib/entities/empty';

import View_DialogWaiting from '../../../lib/views/dialogWaiting/dialogWaiting';
import helper_createWebpage from '../../helper/createWebpage';
import config from '../../../common/config';
import Help from '../../helper/help';
import View_Dialog2Button from '../../../lib/views/dialog2Button/dialog2Button';
import EventUpdate from '../../helper/eventUpdate';
import View_CustomHeader from '../region/customHeader/customHeader';


export default View_LayoutError.extend({
    getTemplate: function () {
        return tpl_customFriendlyUrl({ model: this.model.toJSON() });
    },
    attributes: function () {
        return {
            style: "",
        }
    },
    initialize: function () {
        self = this;

        this.app = this.options.app;

        this.informationCollection = new Entities_Empty.Collection();

        this.setHasChanged(false);
        this.oldModel = this.model.clone();
    },
    help: function () {
        Help.help(this, true, 'custom');
    },
    setHasChanged: function (enable) {
        this.hasChanged = enable;
    },
    getHasChanged: function () {
        return this.hasChanged;
    },
    saveHasChanged: function (callback) {
        this.btnSubmitClick();
        callback();
    },
    cancelHasChanged: function () {
        this.model.attributes = this.oldModel.attributes;
    },
    modelHasChanged: function () {
        var changes = false;

        this.setModel();

        //If culture has change do not ask to save when goes to another menu item
        if (this.model.attributes.FriendlyUrl == this.oldModel.attributes.FriendlyUrl) {
            changes = false;
            //this.btnSubmitClick();
        } else if (this.model.attributes.FriendlyUrl != this.oldModel.attributes.FriendlyUrl) {
            changes = true;
        }

        this.setHasChanged(changes);
    },
    regions: {
        information: "#customInformation"
    },
    onBeforeShow: function () {
        this.information.show(new View_Information({ collection: this.informationCollection, app: this.app }));
    },
    ui: {
        'custom_btnSubmit': '#custom_btnSubmit',
        
        'custom_inputFriendlyUrl': '#custom_inputFriendlyUrl',
        'help': '#help'
    },
    events: {
        'click #custom_btnSubmit': 'btnSubmitClick',
        'click #help': 'help'
    },
    onRender: function () {
    },
    onAttach() {
        
    },
    onDestroy() {
       
    },
    renderInformation: function () {
        this.informationCollection.reset();

        //No customYet yet
        if (this.model.validateNoBackbone(this.model.attributes)) {
            var tmpModel = new this.informationCollection.model({ toastType: 3, header: resources.X100229, Information: resources.X100333 });
            this.informationCollection.add(tmpModel);
        }
        this.app.renderInformation({ informationCollection: this.informationCollection });
    },
    updateInformationCollection: function () {
        this.renderInformation();
        this.informationCollection.trigger('change');
    },
    btnSubmitClick: function (event) {
        if (event != null) {
            event.preventDefault();
        }

        if (this.setModel()) {
            this.save();
        }
    },
    setModel: function () {
        
        this.model.set({
            FriendlyUrl: this.ui.custom_inputFriendlyUrl.val()
        });
        
        return true;
    },
    save: function () {
        var self = this;

        var callback = function (ret) {
            if (ret == false) {

                var dialogWaitingModel = new Entities_Empty.Model();
                dialogWaitingModel.attributes.Title = resources.X100232;
                dialogWaitingModel.attributes.Text = resources.X200093;
                dialogWaitingModel.attributes.Button = resources.X100279;

                var dialogWaiting = new View_DialogWaiting({ model: dialogWaitingModel, parent: self });
                var callback = function (options) {
                    self.stopListening(dialogWaiting, "dialog:okclicked", callback);
                }
                self.listenTo(dialogWaiting, "dialog:okclicked", callback);
                self.app.dialogRegion.show(dialogWaiting);


                self.model.save(self.model.attributes, {
                    route01: false,
                    success: function () {
                        dialogWaiting.triggerMethod('dialog:close');

                        var userChannel = Backbone.Radio.channel('app');
                        userChannel.trigger('Region_Header:setLoginName');

                        self.oldModel = self.model.clone();
                        self.setHasChanged(false);
                    }
                });
            } else {
                self.showErrors(self.model.errors);
            }
        }

        this.hideErrors();

        var ret = this.model.validateNoBackbone(this.model.attributes, callback);
        //if (ret == false) {

        //    var dialogWaitingModel = new Entities_Empty.Model();
        //    dialogWaitingModel.attributes.Title = resources.X100232;
        //    dialogWaitingModel.attributes.Text = resources.X200093;
        //    dialogWaitingModel.attributes.Button = resources.X100279;

        //    var dialogWaiting = new View_DialogWaiting({ model: dialogWaitingModel, parent: this });
        //    var callback = function (options) {
        //        self.stopListening(dialogWaiting, "dialog:okclicked", callback);
        //    }
        //    this.listenTo(dialogWaiting, "dialog:okclicked", callback);
        //    this.app.dialogRegion.show(dialogWaiting);


        //    this.model.save(this.model.attributes, {
        //        route01: false,
        //        success: function () {
        //            dialogWaiting.triggerMethod('dialog:close');

        //            var userChannel = Backbone.Radio.channel('app');
        //            userChannel.trigger('Region_Header:setLoginName');

        //            self.oldModel = this.model.clone();
        //            self.setHasChanged = false;
        //        }
        //    });
        //} else {
        //    this.showErrors(this.model.errors);
        //}
    }
}, Backbone.Radio.Requests);
